{
  "colorFormat": "Μορφή χρώματος",
  "hex": "Hex",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
